<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content m-0">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ 'kanban.cardUpload.title' | translate }}
        </h4>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      <ul class="nav nav-tabs nav-bordered mx-2" role="tablist">
        <li class="nav-item" role="presentation">
          <a
            class="nav-link active"
            id="import-cards-tab"
            data-bs-toggle="tab"
            data-bs-target="#import-cards"
            type="button"
            role="tab"
            aria-controls="import-cards"
            aria-selected="true"
          >
            <i
              class="mdi mdi-cloud-download-outline download-icon d-md-none d-block"
            ></i>
            <span class="d-none d-md-inline"> {{ 'kanban.cardUpload.tabImport' | translate }} </span>
          </a>
        </li>
        <li class="nav-item" role="presentation">
          <a
            class="nav-link"
            id="rules-tab"
            data-bs-toggle="tab"
            data-bs-target="#rules"
            type="button"
            role="tab"
            aria-controls="rules"
            aria-selected="false"
          >
            <i class="mdi mdi-file-document-outline d-md-none d-block"></i>
            <span class="d-none d-md-inline">{{ 'kanban.cardUpload.tabRules' | translate }}</span>
          </a>
        </li>
      </ul>

      <div class="modal-body py-2 scroll">
        <div class="tab-content card-body" id="tabComponentsContent">
          <div
            class="tab-pane fade show active custom-scroll-bar card-upload-csv overflow-x-hidden"
            id="import-cards"
            role="tabpanel"
            aria-labelledby="import-cards-tab"
          >
            <div class="row justify-content-center mb-4">
              <div class="col-10 p-3">
                <div class="horizontal-steps">
                  <div class="horizontal-steps-content">
                    <div class="step-item" [class.current]="stepIndex() === 0">
                      <span>{{ 'kanban.cardUpload.stepUpload' | translate }}</span>
                    </div>
                    <div class="step-item" [class.current]="stepIndex() === 1">
                      <span>{{ 'kanban.cardUpload.stepMap' | translate }}</span>
                    </div>
                    <div class="step-item" [class.current]="stepIndex() === 2">
                      <span>{{ 'kanban.cardUpload.stepPreview' | translate }}</span>
                    </div>
                  </div>
                  <div
                    class="process-line"
                    [style.width]="(stepIndex() / 2) * 100 + '%'"
                  ></div>
                </div>
              </div>

              <div>
                @switch (stepIndex()) {
                  @case (0) {
                    <div class="row mt-3 p-3">
                      <div class="rounded-3">
                        <label
                          for="dropzone-file"
                          class="dz-area w-100"
                          role="button"
                          [attr.aria-label]="'kanban.cardUpload.dropzoneAriaLabel' | translate"
                        >
                          <div class="dz-inner text-center">
                            <i
                              class="mdi mdi-cloud-upload-outline mb-2 upload-icon text-muted font-24"
                            ></i>
                            <div
                              class="fw-semibold font-16 text-secondary mb-1"
                            >
                              {{ 'kanban.cardUpload.clickToUpload' | translate }}
                            </div>
                            <small class="text-muted">
                              {{ 'kanban.cardUpload.csvOnly' | translate }}
                            </small>
                          </div>
                        </label>

                        <input
                          id="dropzone-file"
                          type="file"
                          class="d-none"
                          accept=".csv"
                          (change)="handleSelectFile($event)"
                          #inputFile
                        />
                      </div>

                      @if (fileLoaded) {
                        <div
                          class="alert alert-info d-flex align-items-center justify-content-between gap-2 mt-3"
                          role="alert"
                        >
                          @if (!loading) {
                            <div class="d-flex align-items-center gap-2">
                              <i class="ri-file-user-line font-24"></i>
                              <div class="d-flex flex-column">
                                <span class="text-dark fw-semibold font-16">
                                  {{ file.name }}
                                </span>
                                <small>
                                  {{ formatBytes(file.size) }}
                                </small>
                              </div>
                            </div>
                            <div>
                              <i
                                class="mdi mdi-trash-can-outline text-danger font-18"
                                (click)="clearFile()"
                                role="button"
                              ></i>
                            </div>
                          } @else {
                            <div
                              class="spinner-border d-flex align-items-center justify-content-center"
                              role="status"
                            ></div>
                          }
                        </div>
                      }
                    </div>
                  }
                  @case (1) {
                    <form [formGroup]="formGroup" class="mt-4">
                      @if (!isMappingValid()) {
                        <div class="alert alert-warning py-2 mb-3" role="alert">
                          <i class="mdi mdi-alert-circle-outline me-1"></i>
                          {{ 'kanban.cardUpload.mappingWarning' | translate }}
                        </div>
                      }
                      <div class="row">
                        <div class="col-12 mb-3">
                          <label class="form-label">
                            {{ 'kanban.cardUpload.funnel' | translate }}
                            <span class="text-danger">*</span>
                          </label>
                          <mat-select
                            class="form-control"
                            formControlName="funnel"
                            [placeholder]="'kanban.cardUpload.funnelPlaceholder' | translate"
                          >
                            <div
                              class="overflow-auto"
                              style="max-height: 220px"
                            >
                              @for (item of funnelList; track $index) {
                                <mat-option [value]="item._id">
                                  <!-- (click)="selectFunnel(item)" -->
                                  {{ item.name }}
                                </mat-option>
                              }
                            </div>
                          </mat-select>
                          <field-error-component
                            [field]="'funnel'"
                            [label]="'kanban.cardUpload.funnel' | translate"
                            [formGroup]="formGroup"
                          />
                        </div>
                      </div>
                    </form>
                    <div class="step-card">
                      <div class="table-responsive">
                        <table class="table table-centered mb-0">
                          <thead>
                            <tr>
                              <th>{{ 'kanban.cardUpload.columnFile' | translate }}</th>
                              <th>{{ 'kanban.cardUpload.columnPreview' | translate }}</th>
                              <th>{{ 'kanban.cardUpload.columnTarget' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (
                              map of mappings;
                              track map.csvColumn;
                              let i = $index
                            ) {
                              <tr>
                                <td class="fw-semibold">{{ map.csvColumn }}</td>
                                <td>
                                  <span class="text-muted">
                                    {{ map.sample || "—" }}
                                  </span>
                                </td>
                                <td>
                                  <mat-select
                                    class="form-control"
                                    [value]="map.mappedTo"
                                    (selectionChange)="
                                      onMappingChange(i, $event.value)
                                    "
                                  >
                                    @for (
                                      field of availableFields;
                                      track field.value
                                    ) {
                                      <mat-option [value]="field.value">
                                        {{ field.label | translate }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  }
                  @case (2) {
                    @if (!!csvContent.length) {
                      <div class="step-card mt-4">
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <div class="mb-3">
                            <label class="form-label">
                              {{ 'kanban.cardUpload.totalOpportunities' | translate }}
                            </label>
                            <h5 class="fw-semibold text-center">
                              {{ csvContent.length }}
                            </h5>
                          </div>
                          <div class="mb-3">
                            <label class="form-label">
                              {{ 'kanban.cardUpload.opportunitiesWithoutError' | translate }}
                            </label>
                            <h5 class="fw-semibold text-center">
                              {{ csvContent.length - getErrorCount() }}
                            </h5>
                          </div>
                          <div class="mb-3">
                            <label class="form-label">
                              {{ 'kanban.cardUpload.opportunitiesWithError' | translate }}
                            </label>
                            <h5 class="fw-semibold text-center">
                              {{ getErrorCount() }}
                            </h5>
                            @if (getErrorCount() > 0) {
                              <div class="mb-3 d-flex align-items-end">
                                <button
                                  class="btn btn-sm btn-outline-danger"
                                  type="button"
                                  (click)="removeAllErrors()"
                                >
                                  <i
                                    class="mdi mdi-delete-sweep-outline me-1"
                                  ></i>
                                  {{ 'kanban.cardUpload.removeAllErrors' | translate }}
                                </button>
                              </div>
                            }
                          </div>
                        </div>

                        <div class="table-responsive">
                          <table class="table table-hover table-centered mb-0">
                            <thead>
                              <tr>
                                <th class="text-primary-emphasis">
                                  {{ 'kanban.cardUpload.opportunityName' | translate }}
                                </th>
                                <th class="text-primary-emphasis">{{ 'kanban.cardUpload.customer' | translate }}</th>
                                <th class="text-primary-emphasis">{{ 'kanban.cardUpload.phone' | translate }}</th>
                                <th class="sr-only"></th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (
                                row of paginatedContent;
                                track row.rowIndex
                              ) {
                                <tr role="row">
                                  <td>
                                    <span
                                      [ngClass]="{
                                        'text-danger': row['hasError'],
                                        'text-dark': !row['hasError'],
                                      }"
                                    >
                                      {{ row["name"] || "—" }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      [ngClass]="{
                                        'text-danger': row['hasError'],
                                        'text-dark': !row['hasError'],
                                      }"
                                    >
                                      {{ row["customer"] || "—" }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      [ngClass]="{
                                        'text-danger': row['hasError'],
                                        'text-dark': !row['hasError'],
                                      }"
                                    >
                                      {{ row["phone"] || "—" }}
                                    </span>
                                  </td>
                                  <td class="py-3 pl-3 pr-4 text-right text-sm">
                                    <div role="none">
                                      <a
                                        href="javascript:void(0)"
                                        class="text-danger text-decoration-none"
                                        role="menuitem"
                                        (click)="delete(row)"
                                      >
                                        <i
                                          class="mdi mdi-trash-can-outline"
                                        ></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <mat-paginator
                        [length]="csvContent.length"
                        [pageSize]="pageSize"
                        (page)="handlePage($event)"
                      ></mat-paginator>
                    }
                  }
                }
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade show custom-scroll-bar card-upload-csv overflow-x-hidden"
            id="rules"
            role="tabpanel"
            aria-labelledby="rules-tab"
          >
            <div class="col-xs-12 overflow-x-hidden">
              <div class="row">
                <div class="p-3">
                  <div class="mb-3 custom-scroll-bar card-rules">
                    <div class="mt-3">
                      <p class="mb-3">
                        {{ 'kanban.cardUpload.rulesIntro' | translate }}
                      </p>

                      <p class="fw-bold mb-1">
                        {{ 'kanban.cardUpload.rulesColumnsTitle' | translate }}
                      </p>
                      <ul class="list-circle ps-4 mb-3">
                        <li>{{ 'kanban.cardUpload.rulesColumnsSingleSheet' | translate }}</li>
                        <li [innerHTML]="'kanban.cardUpload.rulesColumnsRequired' | translate"></li>
                        <li [innerHTML]="'kanban.cardUpload.rulesColumnsSeparator' | translate"></li>
                      </ul>

                      <p class="fw-bold mb-1">
                        {{ 'kanban.cardUpload.rulesPhoneTitle' | translate }}
                      </p>
                      <ul class="list-circle ps-4 mb-3">
                        <li>
                          {{ 'kanban.cardUpload.rulesPhoneDdi' | translate }}
                        </li>
                        <li>
                          {{ 'kanban.cardUpload.rulesPhoneNoFormat' | translate }}
                        </li>
                        <li>
                          {{ 'kanban.cardUpload.rulesPhoneNinthDigit' | translate }}
                        </li>
                      </ul>

                      <p class="fw-bold mb-1">{{ 'kanban.cardUpload.rulesCustomerTitle' | translate }}</p>
                      <ul class="list-circle ps-4 mb-3">
                        <li [innerHTML]="'kanban.cardUpload.rulesCustomerRequired' | translate"></li>
                        <li>
                          {{ 'kanban.cardUpload.rulesCustomerReuse' | translate }}
                        </li>
                      </ul>

                      <p class="fw-bold mb-1">{{ 'kanban.cardUpload.rulesSummaryTitle' | translate }}</p>
                      <ul class="list-circle ps-4 mb-3">
                        <li [innerHTML]="'kanban.cardUpload.rulesSummaryRequired' | translate"></li>
                        <li>
                          {{ 'kanban.cardUpload.rulesSummaryPhone' | translate }}
                        </li>
                        <li>
                          {{ 'kanban.cardUpload.rulesSummaryDuplicates' | translate }}
                        </li>
                        <li>{{ 'kanban.cardUpload.rulesSummaryReview' | translate }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div>
          <div class="col-12 gap-2 d-flex justify-content-end">
            <button class="btn btn-outline-secondary" (click)="close()">
              {{ 'kanban.cardUpload.cancel' | translate }}
            </button>

            @if (stepIndex() > 0) {
              <button class="btn btn-dark" (click)="prev()">{{ 'kanban.cardUpload.back' | translate }}</button>
            }

            @if (stepIndex() === 0) {
              <button
                class="btn btn-primary"
                [disabled]="!fileLoaded || loading"
                (click)="onContinueFromUpload()"
              >
                @if (loading) {
                  <span
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {{ 'kanban.cardUpload.wait' | translate }}
                } @else {
                  {{ 'kanban.cardUpload.continue' | translate }}
                }
              </button>
            } @else if (stepIndex() === 1) {
              <button
                class="btn btn-primary"
                (click)="onContinueFromMapping()"
                [disabled]="!isMappingValid()"
              >
                {{ 'kanban.cardUpload.continue' | translate }}
              </button>
            } @else if (stepIndex() === 2) {
              <button
                class="btn btn-primary"
                type="submit"
                [disabled]="
                  loading || !csvContent.length || getErrorCount() > 0
                "
                (click)="save()"
              >
                @if (loading) {
                  <mat-spinner
                    [diameter]="15"
                    [color]="'accent'"
                    mode="indeterminate"
                  />
                } @else {
                  {{ 'kanban.cardUpload.import' | translate }}
                }
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
